const SLICEMACHINE_CONFIG_FILENAME = "slicemachine.config.json";
export {
  SLICEMACHINE_CONFIG_FILENAME
};
//# sourceMappingURL=SLICEMACHINE_CONFIG_FILENAME.js.map
